import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatError, setAssociationId } from "@/lib/api";
import { ROLES } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { Field, Spinner } from "@/components/Field";
import { AuthShell } from "./AuthShell";

export default function AcceptInvitePage() {
  const { token } = useParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const { data: info, error, loading } = useFetch(`/auth/invite/${token}`);
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, name: name || info.email.split("@")[0], password: pw });
      const m = data.memberships.find((x) => x.name === info.association_name) || data.memberships[0];
      if (m) setAssociationId(m.association_id);
      setUser(data);
      nav("/");
    } catch (err) {
      setMsg(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <AuthShell title="Invito"><Spinner /></AuthShell>;
  if (error) return <AuthShell title="Invito non valido"><p data-testid="invite-invalid" className="text-slate-600">{formatError(error)}</p></AuthShell>;

  return (
    <AuthShell title={`Benvenuto in ${info.association_name}`} subtitle={`Sei stato invitato come ${ROLES[info.role]} (${info.email}).`}>
      <form onSubmit={submit} className="space-y-4">
        {!info.existing_user && <Field label="Nome e cognome"><Input data-testid="invite-name-input" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} className="h-12" /></Field>}
        <Field label={info.existing_user ? "La tua password attuale" : "Scegli una password"} hint={info.existing_user ? "Hai già un account: inserisci la tua password" : "Almeno 8 caratteri"}>
          <Input data-testid="invite-password-input" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} className="h-12" />
        </Field>
        {msg && <p data-testid="invite-error" className="text-sm text-red-700">{msg}</p>}
        <Button data-testid="invite-submit-button" type="submit" disabled={busy} className="w-full h-12">{busy ? <Spinner /> : "Accetta invito"}</Button>
      </form>
    </AuthShell>
  );
}
